import React from 'react';
import { css } from '@emotion/react';
import { Grid, CircularProgress } from '@material-ui/core';
import { LoadingContainer } from './blocks';

const Loading = () => {
    return (
        <LoadingContainer
            css={css`
                justify-content: center;
                align-items: center;
            `}
        >
            <Grid
                item
                css={css`
                    margin-top: 128px;
                `}
            >
                <CircularProgress />
            </Grid>
        </LoadingContainer>
    );
};

export default Loading;
